import { Heading } from "grommet";
import React from "react";
import logoImage from "../../assets/images/logo.svg";
import { COLOR_WHITE } from "../../constants/colors";

const Logo = ({
  size = 64,
  type = "default",
  background = COLOR_WHITE,
  color = COLOR_WHITE,
  className,
}: {
  type?: "text" | "default" | "plain";
  size?: number;
  background?: string;
  color?: string;
  className?: string;
}) => {
  if (type === "default") {
    return (
      <img
        className={className}
        src={logoImage}
        alt="Due Logo"
        style={{ background: background, padding: 8, borderRadius: 6 }}
      />
    );
  } else if (type === "plain") {
    return (
      <img
        className={className}
        src={logoImage}
        alt="Due Logo"
        style={{ height: size }}
      />
    );
  } else {
    return (
      <Heading
        className={className}
        style={{
          fontSize: size,
          fontWeight: "bold",
          color: color,
        }}
      >
        DUE
      </Heading>
    );
  }
};

export default Logo;
